



































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import { debounce } from '@/utils/util'
import QuestionList from './QuestionList.vue'
import { TreeSelect } from 'ant-design-vue'
import { hasValue } from '@/utils/util'
import RevisitApi from '@/api/revisit'
const debounceSearch = debounce(300)
const SHOW_PARENT = (TreeSelect as any).SHOW_PARENT
const columns = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '保司名称',
		dataIndex: 'companyName',
		align: 'center',
	},
	{
		title: '操作',
		dataIndex: 'action',
		align: 'center',
		scopedSlots: { customRender: 'action' },
	},
]

@Component({
	components: {
		QuestionList,
	},
})
export default class QuestionnaireForm extends Vue {
	private SHOW_PARENT: any = SHOW_PARENT
	private columns = columns
	private form: any = {}
	private showCompanySelect = false
	private companyStr = ''
	private checkedKeys: any[] = []
	// private defaultCheckedKeys: number[] = []
	private companyResult: any = null
	private companyList: any[] = []
	private companyListTemp: any[] = []
	private saveLoading = false

	@Prop({})
	private templateId!: any

	@Prop({})
	private questionnaire!: any

	private get statusList() {
		return this.$store.state.setting.accountStatusList.map((item: any) => {
			return {
				label: item.value,
				value: item.key,
			}
		})
	}

	@Watch('questionnaire', { immediate: true })
	private onDefaultChange() {
		this.companyList = this.questionnaire.companyList || []
		const name = this.questionnaire.name
		const templateDesc = this.questionnaire.templateDesc
		const status = Number(this.questionnaire.status)
		// 编辑时赋初值
		if (name && templateDesc && hasValue(status)) {
			this.$nextTick(() => {
				this.form.setFieldsValue({ name, templateDesc, status })
			})
		}
	}

	private deleteQuestion(id: string) {
		this.$emit('deleteQuestion', id)
	}

	private changeOrder(changedList: any[]) {
		this.$emit('changeOrder', changedList)
	}

	private go2Add() {
		this.checkedKeys = this.companyList.map((company: any) => ({
			value: company.companyId,
			label: company.companyName,
		}))
		this.companyListTemp = [...this.companyList]
		this.showCompanySelect = true
	}

	private onCompanyChange(value: number[], label: string[]) {
		this.companyListTemp = value.map((item: any, index) => {
			return { companyId: item.value, companyName: item.label }
		})
	}

	private onCompanySave() {
		this.companyList = [...this.companyListTemp]
		this.showCompanySelect = false
	}

	private onCompanyCancel() {
		this.showCompanySelect = false
	}

	private onSearchCompany() {
		debounceSearch(() => {
			if (!this.companyStr) {
				this.setCompany()
				return
			}
			TaskApi.searchCompany(this.companyStr.trim()).then((res: any) => {
				this.companyResult = res.data.map((item: any) => {
					return {
						isLeaf: true,
						key: item.companyId,
						title: item.companyName,
						value: item.companyId,
					}
				})
			})
		})
	}

	// private onCompanyCheck(checkedKeys: any, info: any) {
	//     this.checkedKeys = checkedKeys
	// 	this.companyList = info.checkedNodes.map((node: any) => {
	// 		return {
	// 			id: node.data.props.value,
	// 			name: node.data.props.title,
	// 		}
	// 	})
	// }

	private deleteCompany(id: number) {
		this.companyList = this.companyList.filter((company: any) => {
			return company.companyId !== id
		})
	}

	private goBack() {
		this.$confirm({
			title: '提示',
			content: '返回将放弃本次编辑内容，请确定是否返回？',
			onOk: () => {
				this.$multiTab.closeCurrentPage()
			},
			onCancel() {},
		})
	}

	private onSave() {
		this.form.validateFields((errors: any, values: any) => {
			if (!errors) {
				const questionList = this.questionnaire.questionList
				if (!(questionList && questionList.length > 0)) {
					this.$message.error('请添加题目')
					return
				}

				// if (!(this.companyList && this.companyList.length > 0)) {
				// 	this.$message.error('请选择应用机构')
				// 	return
				// }

				values.companyList = this.companyList.map(
					(company: any) => company.companyId
				)
				values.questionList = questionList.reduce(
					(arr: any[], question: any) => {
						const linkList: any[] = []
						if (question.optionList) {
							question.optionList.forEach((option: any) => {
								if (option.linkQuestionId) {
									linkList.push({
										optionId: option.optionId,
										linkQuestionId: option.linkQuestionId,
									})
								}
							})
						}
						arr.push({
							questionId: question.questionId,
							linkList: linkList,
						})
						return arr
					},
					[]
				)
				if (this.templateId) {
					// 编辑问卷
					values.id = this.templateId
				}

				this.saveLoading = true
				RevisitApi.saveQuestionnaire(values)
					.then((res: any) => {
						this.$message.success(res.data.message || '保存成功')
						setTimeout(() => {
							this.$multiTab.closeCurrentPage()
							this.$multiTab.open('/returnVisit/returnVisitQuestionnaire')
						}, 500)
					})
					.finally(() => {
						this.saveLoading = false
					})
			}
		})
	}

	public setCompany() {
		this.companyResult = [
			{
				value: ' ',
				key: ' ',
				title: '全部',
				isLeaf: true,
			},
		].concat(this.$store.state.setting.companyTree)
	}

	private setRightHeight() {
		debounceSearch(() => {
			const contentEl: any = document.querySelector('.content')
			if (!contentEl) {
				return
			}

			const contentRect: any = contentEl.getBoundingClientRect()
			const contentStyle: any =
				window.getComputedStyle(contentEl) || contentEl.currentStyle
			const rightArea: any = this.$refs.rightArea
			const leftArea: any = this.$refs.leftArea
			if (contentEl && leftArea && rightArea) {
				const contentBottom: number = parseFloat(
					contentStyle && contentStyle.marginBottom
				)
				const finalHeight =
					document.body.clientHeight - contentRect.y - contentBottom
				rightArea.style.height = finalHeight + 'px'
				leftArea.style.height = finalHeight + 'px'
			}
		})
	}

	private deactivated() {
		;(window as any).removeEventListener('resize', this.setRightHeight, false)
	}

	private activated() {
		;(window as any).addEventListener('resize', this.setRightHeight, false)
	}

	private created() {
		this.form = this.$form.createForm(this)

		this.$store.dispatch('setting/initCompanyTree').then((res: any) => {
			this.setCompany()
		})
	}
}
